<template>
    <el-container direction="vertical" class="payroll-list-info-main">
        <div class="header">
            <el-row>
                <el-col>
                    <div class="title">
                        {{ title }}
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="main" v-loading="loading">
            <div class="grid-wrapper">
                <payroll-info-employer-deal
                    :employer-id="employerId"
                    :report-date="reportDate"
                />
            </div>
        </div>
        <div>
            <div class="el-col el-col-8">
                <payroll-info-employer-calculate
                    :employer-id="employerId"
                    :report-date="reportDate"
                />
            </div>
            <div class="el-col el-col-16 block-employer-paid">
                <div class="block-employer-paid-main">
                    <expense-deal-create-popup
                        :is-visible="isExpenseVisible"
                        :expense-id="expenseId"
                        :expense="expense"
                        @changeVisibility="changeVisibility"
                    />
                    <payroll-info-employer-paid
                        :employer-id="employerId"
                        :report-date="reportDate"
                    />
                    <el-button class="spreadsheet-header-button" style="margin-top: 1rem" type="warning" @click="create">
                        Выдать
                    </el-button>
                </div>
            </div>
        </div>
        <div>
            <div class="el-col el-col-8 summary-statistics-employer-block">
                <summary-statistics-employer
                    :employer-id="employerId"
                    :report-date="reportDate"
                    v-if="checkEmployerPosition"
                />
            </div>
        </div>
    </el-container>
</template>

<script>
import localReferences from '@/helpers/localReferences';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSave, faEdit, faTrashAlt, faUndoAlt } from '@fortawesome/free-solid-svg-icons';
import { formatFinance } from '@/common/utilities';
import '@/assets/styles/payroll-list-info.scss';
import '@/assets/styles/print.scss';
import PayrollInfoEmployerDeal from '@/components/salary/PayrollInfoEmployerDeal';
import PayrollInfoEmployerCalculate from '@/components/salary/PayrollInfoEmployerCalculate';
import PayrollInfoEmployerPaid from '@/components/salary/PayrollInfoEmployerPaid';
import ExpenseDealCreatePopup from '@/components/expenses/ExpenseDealCreatePopup';
import SummaryStatisticsEmployer from '@/components/salary/SummaryStatisticsEmployer';
import moment from 'moment';
import dateHelper from '@/helpers/dateHelper';

library.add(faSave, faEdit, faTrashAlt, faUndoAlt);

export default {
    name: 'EmployerPayrollInfoEmployer',
    components: {
        SummaryStatisticsEmployer,
        PayrollInfoEmployerDeal,
        PayrollInfoEmployerCalculate,
        PayrollInfoEmployerPaid,
        ExpenseDealCreatePopup
    },
    data() {
        return {
            localReferences,
            dateList: {},
            employersToPositionsList: {},
            loading: false,
            isExpenseVisible: false,
            expenseId: null,
            expense: {},
            employer: {},
            isLoaded: false
        };
    },
    computed: {
        title() {
            const date = this.reportDate.split('-');
            const title = 'Начисление ЗП на ' + dateHelper.getMonthName(date[1]) + ' ' + date[0];
            if (!this.isLoaded) return title;
            return this.employer.position + ' ' + this.employer.full_name + '. ' + title;
        },
        checkEmployerPosition() {
            const allowedPoitions = [localReferences.employerPositions.manager, localReferences.employerPositions.measurer, localReferences.employerPositions.installer];
            if (allowedPoitions.indexOf(this.employer.position_id) !== -1) {
                return true;
            }
            return false;
        }
    },
    methods: {
        formatFinance,
        create() {
            this.showExpense();
        },
        showExpense(expenseId = -1) {
            this.isExpenseVisible = !this.isExpenseVisible;
            this.expenseId = expenseId;
        },
        changeVisibility() {
            this.$emit('changeVisibility', false);
            this.isExpenseVisible = !this.isExpenseVisible;
            this.expenseId = null;
        },
        async getEmployer() {
            try {
                const response = await this.$store.dispatch('employers/getEmployer', this.employerId);
                this.employer = response.data.data;
                this.isLoaded = true;
            } catch (error) {
                console.log(error);
            }
        }
    },
    beforeMount() {
        this.employerId = this.$route.params.employer_id;
        this.reportDate = this.$route.params.report_date;
    },
    mounted() {
        this.getEmployer();
        this.expense = {
            report_date: this.reportDate,
            recipient_type: 'employer',
            recipient_id: this.employerId,
            date: moment().format('DD.MM.YYYY')
        };
    }
};
</script>
